export type PlatformPriceEntry = {
  key: string
  value: number
}

export const formatPricingLabel = (label: string): string =>
  label
    .replace(/Upto/gi, 'Up to')
    .replace(/Kms/gi, 'km')
    .replace(/\s+/g, ' ')
    .trim()

export const centsToAud = (value: unknown): number => {
  const cents = Number(value ?? 0)
  return Number.isFinite(cents) ? cents / 100 : 0
}

export const formatAud = (value: unknown): string =>
  `$${centsToAud(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`

export const audToCents = (value: unknown): number =>
  Math.round(Number(value || 0) * 100)
